import { useT } from '../context/LanguageContext';
import React, { useState } from 'react';
import { mockData } from '../mock';
import { useContent } from '../context/ContentContext';
import { EditButton } from './admin/EditorShell';
import { SchemaEditor } from './admin/SchemaEditor';
import { DEFAULT_SITE_CONTENT, SITE_CONTENT_SCHEMA } from './admin/SiteContentEditor';
import Logo from './Logo';
import Countdown from './Countdown';
import { useSignup } from '../context/SignupContext';
import { SubmitPhotoButton } from './SubmitPhoto';

const Hero = () => {
  const { t } = useT();
  const { content } = useContent();
  const site = content.site || {};
  const { openSignup } = useSignup();
  const [editingSite, setEditingSite] = useState(false);
  return (
    <section id="top" className="relative overflow-hidden bg-black min-h-[85vh]">
      <div
        data-edit-fields="heroImage"
        className="absolute inset-0 cursor-pointer"
        style={{ backgroundImage: `url(${site.heroImage || mockData.heroImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      />
      <div data-edit-fields="heroImage" className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black cursor-pointer" />

      <div className="relative max-w-[1400px] mx-auto px-4 md:px-8 py-20 md:py-28 lg:py-32 flex flex-col items-center text-center">
        <div data-edit-fields="logoImage" className="cursor-pointer">
          <Logo size="xl" />
        </div>
        <div className="mt-5">
          <EditButton onClick={() => setEditingSite(true)} label="Rediger framside, logo og nettside" testId="edit-site-settings-button" />
        </div>

        <div className="mt-10 md:mt-14 space-y-3">
          <h1 data-edit-fields="eventName" className="cursor-pointer text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight drop-shadow-lg" style={{ fontFamily: "'Oktah Round', sans-serif" }}>
            {site.eventName || mockData.event.name}
          </h1>
          <p data-edit-fields="eventDate,venue" className="cursor-pointer text-[#ff2e2e] text-lg md:text-2xl font-bold uppercase tracking-widest">
            {t(site.eventDate || mockData.event.date)} · {t(site.venue || 'Hjeltefjorden Arena')}
          </p>
          <p data-edit-fields="tagline" className="cursor-pointer max-w-2xl mx-auto text-white/80 text-base md:text-lg leading-relaxed pt-4">
            {t(site.tagline || mockData.event.tagline)}
          </p>
        </div>

        <div className="mt-10">
          <Countdown />
        </div>

        <div className="mt-10 flex flex-col md:flex-row md:flex-wrap items-center justify-center gap-3 md:gap-4 w-full max-w-4xl">
          <button type="button" onClick={openSignup} data-testid="hero-signup-button" className="w-full md:w-auto md:min-w-[220px] px-10 py-4 rounded-full bg-[#ff2e2e] text-black font-bold uppercase tracking-wide hover:bg-[#ff4d4d] transition-colors shadow-lg shadow-[#ff2e2e]/30">
            {t(site.primaryButton || 'Meld deg på')}
          </button>
          <a href="#promo" className="w-full md:w-auto md:min-w-[220px] px-10 py-4 rounded-full border-2 border-[#ff2e2e] text-[#ff2e2e] font-bold uppercase tracking-wide hover:bg-[#ff2e2e] hover:text-black transition-colors">
            {t(site.secondaryButton || 'Sjå trailer')}
          </a>
          <a href="/sporsmal" className="w-full md:w-auto md:min-w-[180px] px-10 py-4 rounded-full border-2 border-white/30 text-white font-bold uppercase tracking-wide hover:border-white hover:bg-white/5 transition-colors">
            {t(site.contactButton || 'Kontakt Oss')}
          </a>
          <SubmitPhotoButton className="w-full md:w-auto md:min-w-[180px] px-8 py-4 rounded-full border-2 border-white/30 text-white font-bold uppercase tracking-wide hover:border-white hover:bg-white/5 transition-colors" />
        </div>
      </div>
      {editingSite && <SchemaEditor contentKey="site" title="Rediger framside, logo og nettside" initial={{ ...DEFAULT_SITE_CONTENT, ...(content.site || {}) }} schema={SITE_CONTENT_SCHEMA} single onClose={() => setEditingSite(false)} />}
    </section>
  );
};

export default Hero;
